import React from "react";
import AppSearchAPIConnector from "@elastic/search-ui-app-search-connector";
import {
  PagingInfo,
  ResultsPerPage,
  Paging,
  Facet,
  SearchProvider,
  Results,
  SearchBox,
  Sorting
} from "@elastic/react-search-ui";
import { Layout } from "@elastic/react-search-ui-views";

import "@elastic/react-search-ui-views/lib/styles/styles.css";
import ResultViewMeals from "./ResultViewMeals";

// endpoint configuration
const connector = new AppSearchAPIConnector({
  engineName: "meals",
  // searchKey: "search-feodmjyfmqinygyb4u1y254k",
  // hostIdentifier: "host-2376rb"
  searchKey: "search-eizxmof1j8qykzphb5i47gj4",
  endpointBase: global.APP_SEARCH_BACKEND_URL,
  hostIdentifier: "DUMMY"
});

const configurationOptions = {
  apiConnector: connector,
  autocompleteQuery: {
    suggestions: {
      types: {
        documents: {
          // Which fields to search for suggestions.
          fields: ["meal"]
        }
      },
      // How many suggestions appear.
      size: 5
    }
  },
  searchQuery: {
    search_fields: {
      // 1. Search by field meal 
      meal: {}
    },
    // 2. Results: meal name, area, category, tags, ingredients, measures, source
    result_fields: {
      meal: {
        // A snippet means that matching search terms will be highlighted via <em> tags.
        snippet: {
          size: 75, // Limit the snippet to 75 characters.
          fallback: true // Fallback to a "raw" result.
        }
      },
      area: {
        snippet: {
          size: 50,
          fallback: true
        }
      },
      category: {
        snippet: {
          size: 50,
          fallback: true
        }
      },
      tags: {
        snippet: {
          size: 50,
          fallback: true
        }
      },
      id: {
        // Ids are numeric, so we won't attempt to snippet these, we'll just use the raw
        // value.
        raw: {}
      },
      meal_thumb: {
        raw: {}
      },
      youtube: {
        raw: {}
      },
      source: {
        raw: {}
      },
      ingredient1: {
        snippet: {
          size: 50,
          fallback: true
        }
      },
      ingredient2: {
        snippet: {
          size: 50,
          fallback: true
        }
      },
      ingredient3: {
        snippet: {
          size: 50,
          fallback: true
        }
      },
      ingredient4: {
        snippet: {
          size: 50,
          fallback: true
        }
      },
      measure1: {
        snippet: {
          size: 50,
          fallback: true
        }
      },
      measure2: {
        snippet: {
          size: 50,
          fallback: true
        }
      },
      measure3: {
        snippet: {
          size: 50,
          fallback: true
        }
      },
      measure4: {
        snippet: {
          size: 50,
          fallback: true
        }
      },
    },
    // 3. Facet by scores, genre, publisher, and platform, which we'll use to build filters later.
    facets: {
      area: { type: "value", size: 100 },
      category: { type: "value", size: 100 },
      tags: { type: "value", size: 100 }
    }
  }
};

export default function MealSearch() {
  return (
    <div className="container marketing no-banner">
        <div className="page-header">
        <div className="btn-toolbar pull-right">
            <div className="btn-group" />
        </div>
          <h3>Meal search (Elasticsearch / Elastic App Search)</h3>
        </div>
        <SearchProvider config={configurationOptions}>
        <div className="App">
            <Layout
            header={<SearchBox autocompleteSuggestions={true} />}
            bodyContent={<Results titleField="meal" urlField="meal_thumb" 
                                  resultView={ResultViewMeals} />}
            sideContent={
                <div>
                <Sorting
                    label={"Sort by"}
                    sortOptions={[
                    {
                        name: "Relevance",
                        value: "",
                        direction: ""
                    },
                    {
                        name: "Meal",
                        value: "meal",
                        direction: "asc"
                    }
                    ]}
                />
                <Facet field="area" label="Area" />
                <Facet field="category" label="Category" />
                <Facet field="tags" label="Tags" isFilterable={true} />
                </div>
            }
            bodyHeader={
                <>
                <PagingInfo />
                <ResultsPerPage />
                </>
            }
            bodyFooter={<Paging />}
            />
        </div>
        </SearchProvider>
    </div>
  );
}
